function TopHeader() {
  return (
    <div className="bg-black h-20 flex px-4 items-center justify-end md:h-auto md:justify-between">
      <img
        src="https://lenostube.b-cdn.net/wp-content/uploads/2022/04/Logo-lenos-2022-ita.png"
        alt="logo"
        style={{ width: "100px", margin: "0px 50px", display: "block" }}
      />
      <nav className="hidden md:flex ml-auto px-10 space-x-2 md:space-x-4 text-white text-sm md:text-base">
        <a
          href="https://www.lenostube.com/en/shop"
          rel="noreferrer"
          target="_blank"
          className="hover:underline"
        >
          Homepage
        </a>
        <span>|</span>
        <a
          href="https://www.lenostube.com/en/shop"
          rel="noreferrer"
          target="_blank"
          className="hover:underline"
        >
          More Services
        </a>
        <span>|</span>
        <a
          href="https://www.lenostube.com/en/all-tools"
          className="hover:underline"
          target="_blank"
          rel="noreferrer"
        >
          Free Tools
        </a>
        <span>|</span>
        <a
          href="https://www.lenostube.com/en/blog"
          rel="noreferrer"
          target="_blank"
          className="hover:underline"
        >
          Blog
        </a>
        <span>|</span>
        <a
          href="https://www.lenostube.com/en/terms-conditions-of-sale"
          className="hover:underline"
          target="_blank"
          rel="noreferrer"
        >
          Terms
        </a>
      </nav>
      {/* <h1 className="bg-black text-white text-center text-3xl font-bold">Fast Code Service</h1> */}
    </div>
  );
}

export default TopHeader;
